import styled from "styled-components";

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledVideo = styled.video`
  width: 100%;
  max-height: 380px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  transform: scaleX(-1);
`;

export const PlacaFrame = styled.div<{ $stable: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 42%;
  border: 3px solid ${({ $stable }) => $stable >= 100 ? "#3b82f6" : $stable > 50 ? "#facc15" : "#22c55e"};
  border-radius: 8px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.35);
  pointer-events: none;
  transition: border-color 0.2s;
`;

export const FrameLabel = styled.span`
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  color: #22c55e;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const StabilityBarWrapper = styled.div`
  width: 70%;
  margin: 32px auto 8px;
  height: 6px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

export const StabilityBarFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${({ $pct }) => $pct}%;
  background: ${({ $pct }) => $pct >= 100 ? "#3b82f6" : $pct > 50 ? "#facc15" : "#22c55e"};
  border-radius: 4px;
  transition: width 0.1s, background 0.2s;
`;

export const StabilityLabel = styled.p`
  font-size: 0.78rem;
  color: #6b7280;
  margin: 0 0 12px;
`;
